import React, { useContext } from "react";
import { createContext, FC } from "react";

import { IHttpRequestConfig } from "@/browser/http";
import { UserContext } from "@/components/User";
import { fetchTasksCount } from "@/data/tasks";
import { useFetcher } from "@/hooks/http";

const emptyContext: ITaskContext = {
  refresh: () => {
    return;
  },
  working: false,
  taskCount: {
    all: 0,
    critical: 0,
    pending: 0,
    urgent: 0,
    unassigned: 0,
  },
};

export interface ITaskCountContext {
  all: number;
  critical: number;
  urgent: number;
  pending: number;
  unassigned: number;
}

interface ITaskContext {
  refresh: () => void;
  working?: boolean;
  taskCount: ITaskCountContext;
}

export const TaskContext = createContext<ITaskContext>(emptyContext);

export const TaskContextProvider: FC = props => {
  const { contextCompany } = useContext(UserContext);

  const taskCountFetcher = useFetcher(
    (_: any, httpConfig: IHttpRequestConfig) => fetchTasksCount({ companyId: contextCompany?.id }, httpConfig),
    {},
    [contextCompany?.id],
  );

  const context: ITaskContext = {
    refresh: taskCountFetcher.fetch,
    working: taskCountFetcher.working,
    taskCount: {
      all: taskCountFetcher.payload?.count ?? 0,
      critical: taskCountFetcher.payload?.criticalTasks ?? 0,
      urgent: taskCountFetcher.payload?.urgentTasks ?? 0,
      pending: taskCountFetcher.payload?.pendingTasks ?? 0,
      unassigned: taskCountFetcher.payload?.unassignedTasks ?? 0,
    },
  };

  return <TaskContext.Provider value={context}>{props.children}</TaskContext.Provider>;
};
